export default __webpack_public_path__ + "dist/media/RightArrow.253f5b33.svg";